import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";

import { OnlyfansGagDialogComponent } from "../../components/onlyfans-gag-dialog/onlyfans-gag-dialog.component";

@Component({
  selector: "app-about-page",
  standalone: true,
  imports: [RouterLink, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, MatDialogModule],
  templateUrl: "./about-page.component.html",
  styleUrl: "./about-page.component.scss"
})
export class AboutPageComponent {
  readonly gageSocial = {
    instagram: "https://www.instagram.com/gtblack4/",
    snapchat: "https://www.snapchat.com/add/gtblack4"
  } as const;

  constructor(private readonly dialog: MatDialog) {}

  openOnlyfansGag(): void {
    this.dialog.open(OnlyfansGagDialogComponent, {
      width: "420px",
      maxWidth: "92vw",
      panelClass: "onlyfans-gag-dialog-shell",
      restoreFocus: false,
      autoFocus: "first-tabbable"
    });
  }
}
